import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@material-ui/core'
import { useReactiveVar } from '@apollo/client'
import { projectVar } from '../../apollo/reactive-vars'
import { Loader } from '../common/Loader'
import { useLayoutStyles } from './use-layout-styles'

type Props = {
  title: string
}

export function CommonProjectTitle({ title }: Props): React.ReactElement {
  const { t } = useTranslation()
  const project = useReactiveVar(projectVar)
  const classes = useLayoutStyles()

  if (!project) {
    return <Loader />
  }
  return (
    <Box>
      <Typography variant="h3">{title}</Typography>
      <Typography className={classes.projectInfo} variant="subtitle1">
        {project.name} • {t('project.projectId')}: {project.projectId}
      </Typography>
    </Box>
  )
}
